import { useEffect } from 'react';
import { useAdpAnalytics } from '@innovyze/stylovyze';
import { ActionPayload, RpcError } from './types';

declare global {
  interface Window {
    bernoulli?: {
      sendMessageToAssistant?: (
        message: string,
        payload?: ActionPayload,
      ) => Promise<{ result?: ActionPayload; error?: RpcError }>;
    };
  }
}

export function useAssistantMessaging() {
  const adpClient = useAdpAnalytics();

  // Expose sendMessageToAssistant on window.bernoulli
  useEffect(() => {
    if (!adpClient) return;

    window.bernoulli = window.bernoulli ?? {};
    window.bernoulli.sendMessageToAssistant = async (message, payload) => {
      console.log('[Bernoulli] sendMessageToAssistant', message, payload);
      try {
        const result = await adpClient.sendMessageToAssistant<
          ActionPayload,
          ActionPayload
        >(message, payload);
        console.log('[Bernoulli] sendMessageToAssistant response', result);
        return { result };
      } catch (error) {
        console.error('[Bernoulli] sendMessageToAssistant error', error);
        return { error: error as RpcError };
      }
    };

    return () => {
      delete window.bernoulli?.sendMessageToAssistant;
    };
  }, [adpClient]);

  // Register handleMessageFromAssistant listener
  useEffect(() => {
    if (!adpClient) return;

    const unsubscribe = adpClient.handleMessageFromAssistant(
      (message, payload) => {
        console.log('[Bernoulli] handleMessageFromAssistant', message, payload);
      },
    );

    return unsubscribe;
  }, [adpClient]);
}
